module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../../ng-src/assets/fonts/glyphicons-halflings-regular.woff2
// module chunks = styles